import { render, staticRenderFns } from "./ssq_sss_yc.vue?vue&type=template&id=053dd834&scoped=true"
import script from "./ssq_sss_yc.vue?vue&type=script&lang=js"
export * from "./ssq_sss_yc.vue?vue&type=script&lang=js"
import style0 from "./ssq_sss_yc.vue?vue&type=style&index=0&id=053dd834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053dd834",
  null
  
)

export default component.exports